exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-project[data-v-114ebe8d] {\n  background-color: #ffffff;\n  border-radius: 2px;\n}\n", ""]);

// exports
